export const getRestrictionType = (channel, currentUserId) => {
  const { restriction_type: restrictionType = null, user_ids: agentIds = [] } =
    channel || {}

  if (
    restrictionType === 'users' &&
    agentIds.length === 1 &&
    agentIds[0] === currentUserId
  )
    return 'me'
  return restrictionType
}
